import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ReactImageMagnify from 'react-image-magnify';
import Img from 'react-image';
import constants from '@ifixit/toolbox/dist/constants/index';

// Minimum and maximum values for enlarged image zoom
// If the zoom source image is too large it will be
// shrunk down to comply with ENLARGED_IMAGE_MAX_ZOOM
// If the zoom source is too small to comply with
// ENLARGED_IMAGE_MIN_ZOOM hover zoom will be turned off
// for that image
const ENLARGED_IMAGE_MIN_ZOOM = 1.5;
const ENLARGED_IMAGE_MAX_ZOOM = 3;

// Default size for the current product image placeholder div
const SMALL_IMAGE_MAX_DIMENSION = 520;

export default class MainProductImage extends Component {
   constructor() {
      super();
      this.state = this.getActiveImageData();

      window.updateMainImage = () => this.setState(this.getActiveImageData());
   }

   getActiveImageData() {
      const activeImageContainer = document.querySelector('.active-image-static');

      const smallImage = {
         src: activeImageContainer.getAttribute('src'),
         alt: activeImageContainer.getAttribute('alt'),
         isFluidWidth: true,
      };

      let shouldShowLargeImage = true;
      let largeImageWidth = parseInt(activeImageContainer.getAttribute('data-full-width'), 10);
      let largeImageHeight = parseInt(activeImageContainer.getAttribute('data-full-height'), 10);

      const enlargedImageMinWidth = SMALL_IMAGE_MAX_DIMENSION * ENLARGED_IMAGE_MIN_ZOOM;
      const enlargedImageMaxWidth = SMALL_IMAGE_MAX_DIMENSION * ENLARGED_IMAGE_MAX_ZOOM;

      if (largeImageWidth < enlargedImageMinWidth) {
         shouldShowLargeImage = false;
      } else if (largeImageWidth > enlargedImageMaxWidth) {
         const shrinkFactor = largeImageWidth / enlargedImageMaxWidth;
         largeImageWidth /= shrinkFactor;
         largeImageHeight /= shrinkFactor;
      }

      let largeImage = {
         src: null,
      };

      if (shouldShowLargeImage) {
         largeImage = {
            src: activeImageContainer.getAttribute('data-zoomsrc'),
            width: largeImageWidth,
            height: largeImageHeight,
         };
      }
      return { largeImage, smallImage };
   }

   updatePosition() {
      // TODO: If possible, remove the hardcoded breakpoint value
      var enlargedImagePosition = window.matchMedia('(max-width: 1000px)').matches
         ? 'over'
         : 'beside';

      this.setState({ enlargedImagePosition });
   }

   componentDidMount() {
      this.updatePosition();
      window.addEventListener('resize', this.updatePosition.bind(this));
   }

   render() {
      return this.state.largeImage.src ? (
         <ReactImageMagnify
            smallImage={this.state.smallImage}
            largeImage={this.state.largeImage}
            isHintEnabled={true}
            hintTextMouse={_js('Hover to zoom')}
            shouldUsePositiveSpaceLens={true}
            imageStyle={{
               maxHeight: SMALL_IMAGE_MAX_DIMENSION,
               maxWidth: SMALL_IMAGE_MAX_DIMENSION,
            }}
            lensStyle={{
               borderRadius: constants.borderRadius,
            }}
            enlargedImageContainerStyle={{
               borderRadius: constants.borderRadius,
            }}
            isActivatedOnTouch={false}
            hintTextTouch={_js('Hold to zoom')}
            fadeDurationInMs={100}
            hoverDelayInMs={50}
            enlargedImagePosition={this.state.enlargedImagePosition}
         />
      ) : (
         <Img src={this.state.smallImage.src} style={{ width: '100%' }} />
      );
   }
}
ReactDOM.render(<MainProductImage />, document.getElementById('MainProductImage'));
